import { render, staticRenderFns } from "./ClientServiceUser.vue?vue&type=template&id=459c9cb1&scoped=true"
import script from "./ClientServiceUser.vue?vue&type=script&lang=js"
export * from "./ClientServiceUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c9cb1",
  null
  
)

export default component.exports